import React, { FunctionComponent } from 'react';
import { cn } from '@companion-professional/webutils';
import { Text, TextLink } from '../Typography';

// NeedHelpContactSupport is a component that displays a message with links to contact (text or email) support for help.
interface NeedHelpContactSupportProps {
  className?: string;
  contactEmail: string;
  contactPhone: string;
}

// This is stateless component that accepts contact email and phone number as props
// which is used to display a message with links to contact (text or email) support for help.
export const NeedHelpContactSupport: FunctionComponent<NeedHelpContactSupportProps> = ({
  className,
  contactEmail,
  contactPhone
}) => {
  return (
    <Text size="sm" tone="muted" className={cn('text-center', className)}>
      Need help?&nbsp;Please&nbsp;
      <TextLink href={`mailto:${contactEmail}`}>email</TextLink>
      &nbsp;or&nbsp;
      <TextLink href={`sms:${contactPhone}`}>text</TextLink>
      &nbsp;support.
    </Text>
  );
};
